import { buildDate } from './buildDate';
import type { DateTimeSettings } from './types';


export const buildNow = (settings: DateTimeSettings) => {
    const nowTimestampSec = Math.floor(Date.now() / 1000);

    return buildDate(nowTimestampSec, settings);
}
